// ==================== JEE ADVANCED TESTS METADATA ====================
// Complex structure: 3 separate folders (Physics/, Chemistry/, Mathematics/)
// Each subject has 17 questions with 4 sections (single, multiple, integer, matching)
export const freeAdvTestsMetadata = {
  'test1': {
    id: 'test1',
    testName: 'JEE Advanced PYQ',
    year: '2024',
    examName: 'JEE-Advanced',
    subject: 'Physics, Chemistry, Mathematics',
    duration: 3 * 60 * 60,
    totalQuestions: 51, // 17 × 3 subjects
    subjects: ["Physics", "Chemistry", "Mathematics"],
    subjectFolders: {
      Physics: 'PYQTestSeries/JeeAdv/Physics',
      Chemistry: 'PYQTestSeries/JeeAdv/Chemistry',
      Mathematics: 'PYQTestSeries/JeeAdv/Mathematics',
    },
    storagePath: 'PYQTestSeries/JeeAdv',
    backLink: '/test-series/pyq/jeeadv',
    subjectStructure: [
      { section: 1, count: 4, type: "singleCorrect" },
      { section: 2, count: 3, type: "multipleCorrect" },
      { section: 3, count: 6, type: "integer" },
      { section: 4, count: 4, type: "matching" },
    ],
    answerKey: {
      Physics: {
        1: "1", 2: "3", 3: "4", 4: "2",
        5: "1,3", 6: "2,4", 7: "1,2,3",
        8: "5", 9: "0", 10: "12", 11: "3", 12: "8", 13: "2",
        14: "1", 15: "4", 16: "2", 17: "3",
      },
      Chemistry: {
        1: "2", 2: "2", 3: "1", 4: "4",
        5: "1,2,4", 6: "3,4", 7: "1,2",
        8: "1", 9: "4", 10: "10", 11: "6", 12: "9", 13: "7",
        14: "2", 15: "3", 16: "1", 17: "4",
      },
      Mathematics: {
        1: "3", 2: "1", 3: "2", 4: "3",
        5: "2,3", 6: "1,4", 7: "1,2,3,4",
        8: "0", 9: "2", 10: "15", 11: "7", 12: "5", 13: "4",
        14: "3", 15: "2", 16: "4", 17: "1",
      },
    }
  }
};

